module.exports = __webpack_public_path__ + "media/dashboard/assets/images/kata/badge-plan-718ea3afc1a1a333c0cabe7cb65c889d.svg";